import { useRef, useState } from "react";
import {
  Button,
  HandleDropDownListChange,
  SearchableFrequencyTypeDropdown,
  SearchableOrganizationDropdown,
  SlideOutModal,
  SlideOutModalProps,
} from "../../../components";
import * as yup from "yup";
import { Formik } from "formik";
import { Form, Row, Col, FloatingLabel, Button as BSButton } from "react-bootstrap";
import { sharedProperty } from "../../../hooks";
import { FrequencyTypeEnum, SubscriptionModel } from "../../../data/entities/billing";

export interface AddSubscriptionModalProps extends SlideOutModalProps {
  showAddState: sharedProperty<boolean>;
  onSubmit: any;
}

export function AddSubscriptionModal(props: Readonly<AddSubscriptionModalProps>) {

  const submitRef = useRef<HTMLButtonElement>(null);

  const validationSchema = yup.object().shape({
    name: yup.string().required("Subscription Name is required"),
    organizationId: yup.number().nullable().optional(),
    startDate: yup.date().required("Start Date is required"),
    price: yup.number().required("Price is required").min(0)
  });

  const initialStartDate = new Date();
  const [organizationName, setOrganizationName] = useState<string>('');

  return (
    <SlideOutModal
      {...props}
      title="Add New Subscription"
      footer={
        <div className="container p-0">
          <div className="row g-0">
            <div className="col-12 pe-2">
              <Button onClick={() => props.showState.setter(false)} variant="cancel" className="w-100">
                Cancel
              </Button>
            </div>
            <div className="col-12 ps-2">
              <Button onClick={() => submitRef.current?.click()} variant="primary" className="w-100">
                Add
              </Button>
            </div>
          </div>
        </div>
      }
    >
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          name: organizationName || "",
          frequency: FrequencyTypeEnum.Monthly,
          organizationId: null,
          startDate:initialStartDate.toLocaleDateString() ,
          price: 0,
        }}
        onSubmit={async (values) => {
          const subscription = {
            ...values,
            organizationId: values.organizationId ? parseInt(values.organizationId) : null,
            startDate: values.startDate ? new Date(values.startDate) : new Date(),
          } as SubscriptionModel;
          props.onSubmit(subscription);
          props.showAddState.setter(false);
        }}
      >
        {({ values, handleSubmit, handleChange, setFieldValue, touched, errors }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <FloatingLabel label="Name" className="mb-3">
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Name"
                      value={values.name}
                      onChange={handleChange}
                      isInvalid={touched.name && !!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Col>
              </Row>

              <Row>
                <Col>
                <Form.Group controlId="organizationId">
                    <SearchableOrganizationDropdown
                    name="organizationId"
                    value={values.organizationId}
                    placeholder="Organization"
                    onChange={(e) => { 
                        HandleDropDownListChange(e, setFieldValue);
                        const selectedOrganizationName = e.target.value.text
                        setFieldValue("name", selectedOrganizationName);
                        setOrganizationName(selectedOrganizationName);
                    }}
                    isInvalid={touched.organizationId && !!errors.organizationId}
                    >
                    <Form.Control.Feedback type="invalid">
                        {errors.organizationId}
                    </Form.Control.Feedback>
                    </SearchableOrganizationDropdown>
                </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                <Form.Group controlId="frequency">
                    <SearchableFrequencyTypeDropdown
                    name="frequency"
                    value={values.frequency}
                    onChange={(e) => HandleDropDownListChange(e, setFieldValue)}
                    isInvalid={touched.frequency && !!errors.frequency}
                    >
                    <Form.Control.Feedback type="invalid">
                        {errors.frequency}
                    </Form.Control.Feedback>
                    </SearchableFrequencyTypeDropdown>
                </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col>
                  <FloatingLabel label="Start Date" className="mb-3">
                    <Form.Control
                      type="date"
                      name="startDate"
                      placeholder="Start Date"
                      value={values.startDate}
                      onChange={handleChange}
                      isInvalid={touched.startDate && !!errors.startDate}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.startDate}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Col>
              </Row>

              <Row>
                <Col>
                  <FloatingLabel label="Price" className="mb-3">
                    <Form.Control
                      type="number"
                      name="price"
                      placeholder="Price"
                      value={values.price}
                      onChange={handleChange}
                      isInvalid={touched.price && !!errors.price}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.price}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Col>
              </Row>


              <BSButton ref={submitRef} type="submit" size="lg" className="d-none" />
            </Form>
          )
        }}
      </Formik>
    </SlideOutModal>
  );
}

export default AddSubscriptionModal;
